import { useGlobalContext } from '~/context/GlobalContext';

export const useExtensionConfig = () => {
  return useGlobalContext().extensionConfig;
};
